import React from 'react';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import Reliance from '../assets/images/brands/reliance.jpg'
import UPL from '../assets/images/brands/upl.jpeg';
import BankSathi from '../assets/images/brands/banksathi.png';
import Samunnati from '../assets/images/brands/samunnati.png';
import Chambal from '../assets/images/brands/chambal.png';
import JumboContainer from './common/JumboContainer';
import KrishiTantra from '../assets/images/brands/krishitantra.png';

import '../styles/Partner.css';
import { useTranslation } from 'react-i18next';
import { PARTNER_LABEL, PARTNER_DESCRIPTION } from '../data/i18n/partner';

const businessPartners = [
  {
    name: 'UPL',
    image: UPL,
    link: 'https://www.upl-ltd.com/in'
  },
  {
    name: 'Reliance Retail',
    image: Reliance,
    link: 'https://relianceretail.com',
  },
  {
    name: 'KrishiTantra',
    image: KrishiTantra,
    link: 'https://krishitantra.com/'
  },
  {
    name: 'Samunnati',
    image: Samunnati,
    link: 'https://samunnati.com/'
  },
  {
    name: 'Chambal Fertilizers',
    image: Chambal,
    link: 'http://chambalfertilisers.com/'
  },
  {
    name: 'Bank Sathi',
    image: BankSathi,
    link: 'https://www.banksathi.com/'
  }
]


const Partners = () => {

  const {t} = useTranslation();

  return (
    <JumboContainer id="partner" white title={t(PARTNER_LABEL)} subtitle={t(PARTNER_DESCRIPTION)}>
      <Row>
        {
          businessPartners.map(partner => (
            <Col xs={6} md={6} lg={4} style={{textAlign: 'center'}}>
              <a
                href={partner.link}
                target="_blank"
                rel="noreferrer"
                className="partner-link"
                >
                <img
                  className="partner-img"
                  src={partner.image}
                  alt={partner.name}
                />
              </a>
            </Col>
          ))
        }
      </Row>
    </JumboContainer>
  )

}

export default Partners;